var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuUseCases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66409 32.2428V32.2642H9.68543H38.7036H38.7249V32.2428V16.8803V16.8589H38.7036H9.68543H9.66409V16.8803V32.2428ZM18.6469 25.8204H18.6256V25.8417V30.2585H16.1078V25.8417V25.8204H16.0865H11.6698V23.3027H16.0865H16.1078V23.2813V18.8646H18.6256V23.2813V23.3027H18.6469H23.0637V25.8204H18.6469ZM9.68543 34.7819C9.00868 34.7819 8.41657 34.5284 7.90822 34.02C7.39986 33.5117 7.14634 32.9196 7.14634 32.2428V16.8803C7.14634 16.2035 7.39986 15.6114 7.90822 15.103C8.41657 14.5947 9.00868 14.3412 9.68543 14.3412H38.7036C39.3804 14.3412 39.9725 14.5947 40.4808 15.103C40.9892 15.6114 41.2427 16.2035 41.2427 16.8803V32.2428C41.2427 32.9196 40.9892 33.5117 40.4808 34.02C39.9725 34.5284 39.3804 34.7819 38.7036 34.7819H9.68543ZM30.3458 28.9205C29.9655 29.3008 29.5227 29.4904 29.0167 29.4904C28.5106 29.4904 28.0679 29.3008 27.6875 28.9205C27.3072 28.5402 27.1177 28.0974 27.1177 27.5914C27.1177 27.0853 27.3072 26.6426 27.6875 26.2622C28.0679 25.8819 28.5106 25.6924 29.0167 25.6924C29.5227 25.6924 29.9655 25.8819 30.3458 26.2622C30.7261 26.6426 30.9156 27.0853 30.9156 27.5914C30.9156 28.0974 30.7261 28.5402 30.3458 28.9205ZM34.1864 22.8182C33.8061 23.1985 33.3634 23.388 32.8573 23.388C32.3512 23.388 31.9085 23.1985 31.5282 22.8182C31.1478 22.4378 30.9583 21.9951 30.9583 21.489C30.9583 20.983 31.1478 20.5402 31.5282 20.1599C31.9085 19.7796 32.3512 19.59 32.8573 19.59C33.3634 19.59 33.8061 19.7796 34.1864 20.1599C34.5668 20.5402 34.7563 20.983 34.7563 21.489C34.7563 21.9951 34.5668 22.4378 34.1864 22.8182Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0426738
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.62505,
    y: 1.92193,
    width: 46.1562,
    height: 46.1562,
    rx: 6.07807,
    stroke: "white",
    strokeWidth: 2.15615
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuUseCases);
export default __webpack_public_path__ + "static/media/icon_menu_use_cases.b788c6d38f5e5158810acd5021b0935e.svg";
export { ForwardRef as ReactComponent };